import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-question-mark text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl text-primary-500">404</p>
      <h1 className="mt-4 text-xl font-medium text-foreground-950 md:text-2xl">
        这片森林里没有你要找的页面
      </h1>
      <p className="mt-2 break-all text-sm text-foreground-500">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          浏览漫画分类
        </Link>
      </div>
    </div>
  );
}